import { Hline } from "../../../components/icons/all-icons";
import rlresume from "./RLresume.module.css"
import shared from "../SharedCSS.module.css"
import RLresumeData from "../../../data/RLresumeData"
import Card from "../../../components/00_resume/Card";
import LanguageCard from "../../../components/00_resume/LanguageCard";
// import BulletPercentage from "../../../components/00_resume/BulletPerc";
import { AirplaneTakeoff, Baby, BehanceLogo, Bicycle, Campfire, Cookie, Envelope, Headphones, LinkedinLogo, MapPin, PersonSimpleRun, Waves } from "phosphor-react";

function RLresume() {

    const data = RLresumeData;

    const CSSHline = `${shared.hline} ${rlresume.hline}`;

    return (
        <main id="resume" className={`${shared.main} ${rlresume.main}`}>
            <div className={shared.header}>
                <p>CURRICULUM VITAE  —  <span>{data?.cvDate}</span></p>
                <div className={shared.me}>
                    <h1>Kian <br/>Segantini</h1>
                    <p>Experience & Qualifications</p>
                </div>
            </div>
            <div className={`${shared.links} ${rlresume.links}`}>
                <div className={`${shared.other} ${rlresume.other}`}><MapPin className={`${shared.icons} ${rlresume.icons}`}/>{data?.links?.location}</div>
                <div className={`${shared.other} ${rlresume.other}`}><Baby className={`${shared.icons} ${rlresume.icons}`}/>January 16th, 2009</div>
                <div className={`${shared.other} ${rlresume.other}`}><Waves className={`${shared.icons} ${rlresume.icons}`}/><Bicycle className={`${shared.icons} ${rlresume.icons}`}/><PersonSimpleRun className={`${shared.icons} ${rlresume.icons}`}/></div>
                <a href={data?.links?.mail} target="_blank" rel="noreferrer" className={`${shared.link} ${rlresume.link}`}><Envelope className={`${shared.icons} ${rlresume.icons}`}/></a>
                <a href="/resume" className={`${shared.other} ${rlresume.other}`}><Campfire className={`${shared.icons} ${rlresume.icons}`}/><Cookie className={`${shared.icons} ${rlresume.icons}`}/><Headphones className={`${shared.icons} ${rlresume.icons}`}/><AirplaneTakeoff className={`${shared.icons} ${rlresume.icons}`}/></a>
                <a href={data?.links?.behance} target="_blank" rel="noreferrer" className={`${shared.link} ${rlresume.link}`}><BehanceLogo className={`${shared.icons} ${rlresume.icons}`}/></a>
                <a href={data?.links?.linkedin} target="_blank" rel="noreferrer" className={`${shared.link} ${rlresume.link}`}><LinkedinLogo className={`${shared.icons} ${rlresume.icons}`}/></a>
            </div>
            <div className={`${shared.resumeSection} ${shared.introduction}`}>
                <div className={`${shared.sectionTitle} ${rlresume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[0]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <p>{data?.introduction?.text}</p>
            </div>
            <div className={`${shared.resumeSection} ${shared.education}`}>
                <div className={`${shared.sectionTitle} ${rlresume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[1]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.cards}>
                    {data?.education?.cards.map((card, index) => (
                        <Card
                            key={index}
                            className={shared.card}
                            start={card.start}
                            end={card.end}
                            title={card.title}
                            subtitle1={card.subtitle1}
                            subtitle2={card.subtitle2}
                        />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.languages}`}>
                <div className={`${shared.sectionTitle} ${rlresume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[2]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.LGcards}>
                    {data?.languages?.map((lang, index) => (
                        <LanguageCard
                            key={index}
                            language={lang.language}
                            level={lang.level}
                            percentage={lang.percentage}
                            />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.certifications}`}>
                <div className={`${shared.sectionTitle} ${rlresume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[3]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.cards}>
                    {data?.certifications?.cards.map((card, index) => (
                        <Card
                            key={index}
                            className={shared.card}
                            start={card.start}
                            end={card.end}
                            title={card.title}
                            subtitle1={card.subtitle1}
                            subtitle2={card.subtitle2}
                        />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.sports}`}>
                <div className={`${shared.sectionTitle} ${rlresume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[4]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.cards}>
                    {data?.sports?.cards.map((card, index) => (
                        <Card
                            key={index}
                            className={shared.card}
                            start={card.start}
                            end={card.end}
                            title={card.title}
                            subtitle1={card.subtitle1}
                            subtitle2={card.subtitle2}
                        />
                    ))}
                </div>
            </div>
            <div className={`${shared.resumeSection} ${shared.experience}`}>
                <div className={`${shared.sectionTitle} ${rlresume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[5]}</h2>
                    <Hline className={CSSHline} />
                </div>
                <div className={shared.cards}>
                    {data?.experience?.cards.map((card, index) => (
                        <Card
                            key={index}
                            className={shared.card}
                            start={card.start}
                            end={card.end}
                            title={card.title}
                            subtitle1={card.subtitle1}
                            subtitle2={card.subtitle2}
                            link={card.link}
                        />
                    ))}
                </div>
            </div>
            {/* <div className={`${shared.resumeSection} ${shared.skills}`}>
                <div className={`${shared.sectionTitle} ${rlresume.sectionTitle}`}>
                    <h2>{data?.sectionTitles[6]}</h2>
                    <Hline className={CSSHline} />
                </div>
                    <div className={shared.skillpercs}>
                        {data?.skills?.map((lang, index) => (
                            <BulletPercentage key={index} title={lang.title} percentage={lang.percentage} />
                        ))}
                    </div>
            </div> */}

        </main>
    );
}

export default RLresume;
